import React from 'react';
import BackButton from '../BackButton/BackButton';
import { Container, ContentContainer, HeaderRow, TitleContainer, AbsoluteContentWrapper } from './Header.styles';

export type HeaderProps = {
  title?: string
  showBackButton?: boolean
  $transparent?: boolean
  onBackClick?: () => void
  children?: React.ReactNode
}

/**
 * Header component with two variants: with and without back button.
 * The title can be either text or an icon.
 * Children are placed below the header row (back button and title).
 */
const Header = ({
  title,
  showBackButton = false,
  $transparent = false,
  onBackClick,
  children,
}: HeaderProps) => {
  return (
    <Container $transparent={$transparent}>
      <HeaderRow>
        {showBackButton && (
          <BackButton onClick={onBackClick} size="large" />
        )}
        {title && <TitleContainer data-has-back-button={showBackButton}>
          {title}
        </TitleContainer>}

        {/* if children are present and title is not present and back button is present, render children on absolute position */}
        {children && !title && showBackButton &&
          <AbsoluteContentWrapper>
            <ContentContainer>{children}</ContentContainer>
          </AbsoluteContentWrapper>
        }

        {/* if children are present and title is not present and back button is not present, render children below the header row */}
        {children && !title && !showBackButton &&
          <ContentContainer>{children}</ContentContainer>
        }

      </HeaderRow>
      {/* if title and children are present, render children below the header row */}
      {children && title && <ContentContainer>{children}</ContentContainer>}
    </Container>
  );
};

export default Header;
